export enum Experiment {
  UseLocalizationService = 'specs.myAccount.UseLocalizationService',
}
